// extracted by mini-css-extract-plugin
export default {"badgeContainer":"Badges_badgeContainer__S0x4p","chip":"Badges_chip__d+RvN","badgeTitle":"Badges_badgeTitle__lwlH0"};